export default {
  'pdfTemplateGenerationMapping.title': 'Notificaciones / Mapeo Adjuntos',

  'pdfTemplateGenerationMapping.form.templateGenerationFormat': 'Formato a Generar',
  'pdfTemplateGenerationMapping.form.pdfTemplate': 'Plantilla',
  'pdfTemplateGenerationMapping.form.documentNamePattern': 'Patrón Nombre Documento',
  'pdfTemplateGenerationMapping.form.select.PDF': 'Formato PDF',
  'pdfTemplateGenerationMapping.form.select.Word': 'Formato Word',
};
